/* Zvelt draft: native Shopify model-viewer, no product media or cart writes. */
(() => {
  if (customElements.get('zm-product-3d')) return;
  let viewerReady;
  function loadViewer() {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!viewerReady) viewerReady = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) return reject(new Error('Shopify viewer unavailable'));
      const timer = setTimeout(() => reject(new Error('Viewer timeout')), 20000);
      Shopify.loadFeatures([{name:'model-viewer', version:'1.12', onLoad(error) {
        if (error) { clearTimeout(timer); reject(error); return; }
        customElements.whenDefined('model-viewer').then(() => {clearTimeout(timer); resolve();});
      }}]);
    }).catch(error => {viewerReady = undefined; throw error;});
    return viewerReady;
  }
  class ZveltProduct3D extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-3d-config]').textContent);
      this.viewer = this.querySelector('model-viewer');
      this.status = this.querySelector('[data-3d-status]');
      const opts = {signal:this.abort.signal};
      this.querySelector('[data-3d-start]').addEventListener('click', () => this.start(), opts);
      this.querySelector('[data-3d-retry]').addEventListener('click', () => this.start(), opts);
      this.addEventListener('click', e => this.onClick(e), opts);
      document.addEventListener('variant:change', e => {
        if (this.config.variants.some(v => String(v.id) === String(e.detail?.variant?.id))) this.sync(e.detail.variant.id);
      }, opts);
      this.viewer.addEventListener('load', () => {
        clearTimeout(this.modelTimer);
        if (this.viewer.availableAnimations?.length) {
          this.viewer.play({repetitions:1});this.viewer.pause();this.viewer.currentTime=0;
        }
        this.dataset.state = 'ready';this.loading = false;
        this.sync(this.selected || this.config.selected);
        this.status.textContent = this.config.messages.ready;
        this.querySelectorAll('[data-view-control]').forEach(b => b.disabled = false);
        if (this.followAnchor && location.hash === '#zvelt-3d') {
          const align=()=>requestAnimationFrame(()=>this.scrollIntoView({block:'start',behavior:'instant'}));
          if (document.readyState === 'complete') align();
          else window.addEventListener('load',align,{once:true,signal:this.abort.signal});
          this.followAnchor=false;
        }
      }, opts);
      this.viewer.addEventListener('error', () => this.fail(), opts);
      this.querySelector('[data-3d-opening]')?.addEventListener('input', e => this.setOpening(Number(e.target.value)), opts);
      document.querySelectorAll('[data-3d-jump]').forEach(a => a.addEventListener('click', () => {this.followAnchor=true;this.start();}, opts));
      this.sync(this.config.selected);
      // Load only on intentional interaction; no WebGL or GLB on ordinary page load.
      if (location.hash === '#zvelt-3d') {this.followAnchor=true;this.start();}
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort = null;cancelAnimationFrame(this.animation);clearTimeout(this.modelTimer);
    }
    async start() {
      if (this.dataset.state === 'ready' || this.loading) return;
      const retry=this.dataset.state === 'error';
      this.loading = true;this.dataset.state = 'loading';this.status.textContent = this.config.messages.loading;
      try {
        await loadViewer();
        if (!this.isConnected) return;
        const source=new URL(this.config.src,location.href);
        if (retry) source.searchParams.set('zm_retry',Date.now());
        this.modelTimer=setTimeout(()=>this.fail(),30000);
        this.viewer.src = source.href;
        this.viewer.dismissPoster?.();
      } catch {this.fail();}
    }
    fail() {
      clearTimeout(this.modelTimer);
      this.loading = false;this.dataset.state = 'error';this.status.textContent = this.config.messages.error;
      this.querySelectorAll('[data-view-control]').forEach(b => b.disabled = true);
    }
    sync(id) {
      const variant = this.config.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.selected = variant.id;this.dataset.variant = variant.id;
      this.viewer.setAttribute('variant-name',variant.finish);
      this.querySelector('[data-3d-finish-name]').textContent = variant.title;
      this.querySelectorAll('[data-3d-variant]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset['3dVariant'] === String(id))));
      const poster = this.querySelector('[data-3d-poster]');
      if (variant.image && poster) poster.src = variant.image;
      this.querySelectorAll('[data-3d-size]').forEach(a => {
        const matches = JSON.parse(a.dataset.variants);
        const v = matches.find(v => v.finish === variant.finish);
        const url = new URL(a.dataset.productUrl,location.origin);
        if (v) url.searchParams.set('variant',v.id);
        url.hash = 'zvelt-3d';a.href=url.pathname+url.search+url.hash;
      });
    }
    onClick(e) {
      const b=e.target.closest('button');if (!b) return;
      if (b.hasAttribute('data-3d-variant')) {
        const id=b.dataset['3dVariant'];
        const picker=[...document.querySelectorAll('hdt-variant-picker')].find(p => p.getAttribute('handle') === this.config.handle);
        const variant=this.config.variants.find(v => String(v.id) === id);
        // Use the theme's real option input: price, photos, URL, stock and cart agree.
        const input=picker && [...picker.querySelectorAll('input[is-value]')].find(i=>i.value===variant?.option);
        if (input) input.click();
        else if (picker?.selectVariantByID) picker.selectVariantByID(id,false);
        const actual=picker?.masterInput?.value;
        if (actual) this.sync(actual);
      }
      if (b.hasAttribute('data-3d-reset')) {
        this.viewer.cameraOrbit=this.config.orbit;this.viewer.cameraTarget='auto auto auto';
        this.viewer.fieldOfView='30deg';this.viewer.resetTurntableRotation?.();
      }
      if (b.hasAttribute('data-3d-front')) this.viewer.cameraOrbit=this.config.kind==='shelf'?'0deg 15deg 105%':'0deg 90deg 105%';
      if (b.hasAttribute('data-3d-back')) this.viewer.cameraOrbit='180deg 75deg 105%';
      if (b.hasAttribute('data-3d-turn')) {
        const next=!this.viewer.autoRotate;this.viewer.autoRotate=next;b.setAttribute('aria-pressed',String(next));
      }
      if (b.hasAttribute('data-3d-door')) {
        const range=this.querySelector('[data-3d-opening]');
        const from=Number(range.value),to=from>50?0:100,start=performance.now();
        cancelAnimationFrame(this.animation);
        const duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:650;
        const tick=now=>{
          const t=duration?Math.min(1,(now-start)/duration):1;
          this.setOpening(from+(to-from)*(t*t*(3-2*t)));
          if(t<1)this.animation=requestAnimationFrame(tick);
        };this.animation=requestAnimationFrame(tick);
      }
    }
    setOpening(percent) {
      if (!this.viewer.duration) return;
      this.viewer.pause();this.viewer.currentTime=this.viewer.duration*Math.min(.9999,percent/100);
      this.querySelector('[data-3d-opening]').value=percent;
      const b=this.querySelector('[data-3d-door]');
      b.textContent=percent>50?this.config.messages.close:this.config.messages.open;
      b.setAttribute('aria-pressed',String(percent>50));
    }
  }
  customElements.define('zm-product-3d',ZveltProduct3D);
})();
